import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Callout, Checkbox, Collapsible, Divider, getTestId, BLACK_300, isValidObject, StateConfigContext } from '@airtel/air-design-system';
import { debounce, merge } from 'lodash';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Keyboard, View } from 'react-native';
import { getSkycFormWidgetStyles } from '../../SkycFormWidgetStyles';
import { identityProofConfig, successAvatarConfig } from './IdentityProofConfig';
import { extractFileData, getHintText, getIdentityProofStyles, getIsDisabledState, getSubHeading, isValidIdentityProof, validateFileInput } from './IdentityProofUtils';
import { IdentityTitleSection } from './components/identity-title-section';
import { ProofSection } from './components/proof-section';
export var IdentityProof = props => {
  var _a, _b;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _useMemo = useMemo(() => merge({}, identityProofConfig, props), [identityProofConfig, props]),
    variant = _useMemo.variant,
    _useMemo$testID = _useMemo.testID,
    testID = _useMemo$testID === void 0 ? 'IdentityProof' : _useMemo$testID,
    _state = _useMemo.state,
    successStateHeading = _useMemo.successStateHeading,
    isExpanded = _useMemo.isExpanded,
    disableToggle = _useMemo.disableToggle,
    autoFormSubmitDebounceDelay = _useMemo.autoFormSubmitDebounceDelay,
    isAutoFormSubmitDebounceAllowed = _useMemo.isAutoFormSubmitDebounceAllowed,
    style = _useMemo.style,
    onUserAction = _useMemo.onUserAction,
    id = _useMemo.id,
    _stepDetails = _useMemo.stepDetailsProps,
    onStepDetailsListItemPressMetaData = _useMemo.onStepDetailsListItemPressMetaData,
    onStepDetailsCtaPressMetaData = _useMemo.onStepDetailsCtaPressMetaData,
    inputsDataProps = _useMemo.inputsDataProps,
    checkboxProps = _useMemo.checkboxProps,
    onCheckboxActionCtaPressMetaData = _useMemo.onCheckboxActionCtaPressMetaData,
    onValidFormMetaData = _useMemo.onValidFormMetaData,
    onInValidFormMetaData = _useMemo.onInValidFormMetaData,
    dropdownsDataProps = _useMemo.dropdownsDataProps,
    uploadsDataProps = _useMemo.uploadsDataProps,
    calloutProps = _useMemo.calloutProps,
    uploadDataText = _useMemo.uploadDataText;
  var idProofDropDown = dropdownsDataProps.idProofDropDown,
    addressProofDropDown = dropdownsDataProps.addressProofDropDown;
  var uploadBackAddressProof = uploadsDataProps.uploadBackAddressProof,
    uploadFrontAddressProof = uploadsDataProps.uploadFrontAddressProof,
    uploadBackIdProof = uploadsDataProps.uploadBackIdProof,
    uploadFrontIdProof = uploadsDataProps.uploadFrontIdProof;
  var _useState = useState(inputsDataProps === null || inputsDataProps === void 0 ? void 0 : inputsDataProps.addressProof),
    addressProofInputProps = _useState[0],
    setAddressProofInputProps = _useState[1];
  var _useState2 = useState(inputsDataProps === null || inputsDataProps === void 0 ? void 0 : inputsDataProps.identityProof),
    idProofInputProps = _useState2[0],
    setIdProofInputProps = _useState2[1];
  var _useState3 = useState(''),
    addressProofValue = _useState3[0],
    setAddressProofValue = _useState3[1];
  var _useState4 = useState(''),
    addressProofNumber = _useState4[0],
    setAddressProofNumber = _useState4[1];
  var _useState5 = useState(''),
    idProofValue = _useState5[0],
    setIdProofValue = _useState5[1];
  var _useState6 = useState(''),
    idProofNumber = _useState6[0],
    setIdProofNumber = _useState6[1];
  var _useState7 = useState((_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.checked) !== null && _a !== void 0 ? _a : false),
    checked = _useState7[0],
    setChecked = _useState7[1];
  var _useState8 = useState(isExpanded),
    isExpandedState = _useState8[0],
    setIsExpandedState = _useState8[1];
  var _useState9 = useState(_state),
    stateType = _useState9[0],
    setStateType = _useState9[1];
  var _useState10 = useState((_b = _stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeading) !== null && _b !== void 0 ? _b : ''),
    subHeading = _useState10[0],
    setSubHeading = _useState10[1];
  var _useState11 = useState(false),
    showFrontUploadFiles = _useState11[0],
    setShowFrontUploadFiles = _useState11[1];
  var _useState12 = useState({
      title: 'Front side',
      subTitle: '',
      state: 'none',
      showDeleteIcon: false,
      hintText: ''
    }),
    frontfileUpload = _useState12[0],
    setFrontfileUpload = _useState12[1];
  var _useState13 = useState(false),
    showBackUploadFiles = _useState13[0],
    setShowBackUploadFiles = _useState13[1];
  var _useState14 = useState({
      title: 'Back side',
      subTitle: '',
      state: 'none',
      showDeleteIcon: false,
      hintText: ''
    }),
    backfileUpload = _useState14[0],
    setBackfileUpload = _useState14[1];
  var _useState15 = useState(false),
    showFrontIdenityUploadFiles = _useState15[0],
    setShowFrontIdentityUploadFiles = _useState15[1];
  var _useState16 = useState({
      title: 'Front side',
      subTitle: '',
      state: 'none',
      showDeleteIcon: false,
      hintText: ''
    }),
    frontfileIdentityUpload = _useState16[0],
    setFrontfileIdenityUpload = _useState16[1];
  var _useState17 = useState(false),
    showBackIdentityUploadFiles = _useState17[0],
    setShowBackIdentityUploadFiles = _useState17[1];
  var _useState18 = useState({
      title: 'Back side',
      subTitle: '',
      state: 'none',
      showDeleteIcon: false,
      hintText: ''
    }),
    backfileIdentityUpload = _useState18[0],
    setBackfileIdentityUpload = _useState18[1];
  var isDisabledState = stateType === 'disabled';
  var isSuccessState = stateType === 'success';
  var skycFormWidgetStyle = getSkycFormWidgetStyles(props);
  var identityProofWidgetStyle = getIdentityProofStyles();
  useEffect(() => {
    setSubHeading(_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeading);
  }, [_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeading]);
  useEffect(() => {
    setStateType(_state);
    setIsExpandedState(_state === 'none');
  }, [_state]);
  useEffect(() => {
    setChecked(checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.checked);
  }, [checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.checked]);
  useEffect(() => {
    setIsExpandedState(isExpanded);
    if (!isExpanded) Keyboard.dismiss();
  }, [isExpanded]);
  var useDebouncedFunction = callback => {
    return useCallback(debounce(callback, autoFormSubmitDebounceDelay), [autoFormSubmitDebounceDelay]);
  };
  var functionDebounce = useDebouncedFunction((metaData, formData) => {
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, metaData), formData);
  });
  var handleValidation = args => {
    var addressProofValue = args.addressProofValue,
      addressProofNumber = args.addressProofNumber,
      isChecked = args.isChecked,
      idProofValue = args.idProofValue,
      idProofNumber = args.idProofNumber,
      frontfileUpload = args.frontfileUpload,
      backfileUpload = args.backfileUpload,
      frontfileIdentityUpload = args.frontfileIdentityUpload,
      backfileIdentityUpload = args.backfileIdentityUpload;
    var handleUserAction = metaData => {
      var formData = {
        addressProofValue,
        addressProofNumber,
        isChecked,
        idProofValue,
        idProofNumber,
        frontfileUpload,
        backfileUpload,
        frontfileIdentityUpload,
        backfileIdentityUpload
      };
      if (isValidObject(metaData)) {
        if (isAutoFormSubmitDebounceAllowed) {
          functionDebounce(metaData, formData);
        } else {
          onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, metaData), formData);
        }
      }
    };
    var isValid = isValidIdentityProof(args);
    if (isValid) {
      if (isChecked) {
        getSubHeading(addressProofValue, addressProofNumber, _stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeading);
      } else {
        getSubHeading(addressProofValue, addressProofNumber, _stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeading, idProofValue, idProofNumber);
      }
    }
    handleUserAction(isValid ? onValidFormMetaData : onInValidFormMetaData);
  };
  var handleTextChange = (value, proofType) => {
    setStateType('none');
    setSubHeading('');
    var updateProps = (inputProps, setInputProps) => {
      var updatedProps = Object.assign(Object.assign({}, inputProps), {
        value,
        hintText: inputProps.state === 'error' ? '' : inputProps.hintText,
        state: 'none',
        showLoader: false
      });
      setInputProps(updatedProps);
      if (updatedProps.onChangeMetaData) {
        onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, updatedProps.onChangeMetaData), updatedProps);
      }
    };
    if (proofType === 'address') {
      setAddressProofNumber(value);
      if (checked) {
        setIdProofNumber(value);
      }
      updateProps(addressProofInputProps, setAddressProofInputProps);
      handleValidation({
        addressProofValue,
        addressProofNumber: value,
        isChecked: checked,
        idProofValue,
        idProofNumber: checked ? value : idProofNumber,
        frontfileUpload,
        backfileUpload,
        frontfileIdentityUpload,
        backfileIdentityUpload
      });
    } else if (proofType === 'identity') {
      setIdProofNumber(value);
      updateProps(idProofInputProps, setIdProofInputProps);
      handleValidation({
        addressProofValue,
        addressProofNumber,
        isChecked: checked,
        idProofValue,
        idProofNumber: value,
        frontfileUpload,
        backfileUpload,
        frontfileIdentityUpload,
        backfileIdentityUpload
      });
    }
  };
  var onCheckboxPress = data => {
    setChecked(prevState => {
      var newCheckedState = !prevState;
      var updatedIdProofValue = newCheckedState ? addressProofValue : '';
      var updatedIdProofNumber = newCheckedState ? addressProofNumber : '';
      var updatedFrontfileIdentityUpload = newCheckedState ? Object.assign({}, frontfileUpload) : {};
      var updatedBackfileIdentityUpload = newCheckedState ? Object.assign({}, backfileUpload) : {};
      if (newCheckedState) {
        setIdProofValue(updatedIdProofValue);
        setIdProofNumber(updatedIdProofNumber);
        setFrontfileIdenityUpload(updatedFrontfileIdentityUpload);
        setBackfileIdentityUpload(updatedBackfileIdentityUpload);
        setShowFrontIdentityUploadFiles(true);
        setShowBackIdentityUploadFiles(true);
      } else {
        setIdProofValue('');
        setIdProofNumber('');
        setFrontfileIdenityUpload({});
        setBackfileIdentityUpload({});
        setShowFrontIdentityUploadFiles(false);
        setShowBackIdentityUploadFiles(false);
      }
      handleValidation({
        addressProofValue,
        addressProofNumber,
        isChecked: newCheckedState,
        idProofValue: updatedIdProofValue,
        idProofNumber: updatedIdProofNumber,
        frontfileUpload,
        backfileUpload,
        frontfileIdentityUpload: updatedFrontfileIdentityUpload,
        backfileIdentityUpload: updatedBackfileIdentityUpload
      });
      (checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onChangeMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onChangeMetaData), Object.assign(Object.assign(Object.assign({}, data), {
        checked: newCheckedState
      }), props)));
      return newCheckedState;
    });
  };
  var handleProofOnPressIn = proofType => {
    var proofInputProps = proofType === 'address' ? addressProofInputProps : idProofInputProps;
    (proofInputProps === null || proofInputProps === void 0 ? void 0 : proofInputProps.onClickMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, proofInputProps === null || proofInputProps === void 0 ? void 0 : proofInputProps.onClickMetaData), Object.assign({}, proofInputProps)));
  };
  var handleOnValidInputMetaData = proofType => {
    var proofInputProps = proofType === 'address' ? addressProofInputProps : idProofInputProps;
    (proofInputProps === null || proofInputProps === void 0 ? void 0 : proofInputProps.onValidInputMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, proofInputProps === null || proofInputProps === void 0 ? void 0 : proofInputProps.onValidInputMetaData), Object.assign({}, proofInputProps)));
  };
  var handleDropdownChange = (data, dropdownType) => {
    var _a;
    var value = (_a = data[2]) === null || _a === void 0 ? void 0 : _a.value;
    setStateType('none');
    setSubHeading('');
    var updatedProps = {
      value,
      state: 'none'
    };
    var updatedAddressProofValue = addressProofValue;
    var updatedIdProofValue = idProofValue;
    if (dropdownType === 'address') {
      updatedAddressProofValue = value;
      setAddressProofValue(updatedAddressProofValue);
      if (checked) {
        updatedIdProofValue = value;
        setIdProofValue(updatedIdProofValue);
      }
      if (addressProofDropDown === null || addressProofDropDown === void 0 ? void 0 : addressProofDropDown.onChangeMetaData) {
        onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, addressProofDropDown.onChangeMetaData), updatedProps);
      }
    }
    if (dropdownType === 'identity') {
      updatedIdProofValue = value;
      setIdProofValue(updatedIdProofValue);
      if (idProofDropDown === null || idProofDropDown === void 0 ? void 0 : idProofDropDown.onChangeMetaData) {
        onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, idProofDropDown.onChangeMetaData), updatedProps);
      }
    }
    handleValidation({
      addressProofValue: dropdownType === 'address' ? updatedAddressProofValue : addressProofValue,
      addressProofNumber,
      isChecked: checked,
      idProofValue: dropdownType === 'identity' ? updatedIdProofValue : idProofValue,
      idProofNumber,
      frontfileUpload,
      backfileUpload,
      frontfileIdentityUpload,
      backfileIdentityUpload
    });
  };
  var handleFileUpload = (metaData, type) => {
    var _a, _b, _c;
    var fileInput = (_b = (_a = metaData[0]) === null || _a === void 0 ? void 0 : _a.event) === null || _b === void 0 ? void 0 : _b.target;
    var file = (_c = fileInput === null || fileInput === void 0 ? void 0 : fileInput.files) === null || _c === void 0 ? void 0 : _c[0];
    var fileData = extractFileData(fileInput);
    if (!fileData) return;
    var _validateFileInput = validateFileInput(fileInput),
      isSizeValid = _validateFileInput.isSizeValid,
      isTypeValid = _validateFileInput.isTypeValid;
    var validFile = isSizeValid && isTypeValid;
    var updatedFrontFileUpload = frontfileUpload;
    var updatedBackFileUpload = backfileUpload;
    var updatedFrontIdentityUpload = frontfileIdentityUpload;
    var updatedBackIdentityUpload = backfileIdentityUpload;
    var onChangeMetaData = {};
    if (validFile) {
      switch (type) {
        case 'addressFront':
          updatedFrontFileUpload = Object.assign({}, fileData);
          setFrontfileUpload(prev => Object.assign(Object.assign({}, prev), updatedFrontFileUpload));
          setShowFrontUploadFiles(true);
          if (checked) {
            updatedFrontIdentityUpload = Object.assign({}, fileData);
            setFrontfileIdenityUpload(prev => Object.assign(Object.assign({}, prev), updatedFrontIdentityUpload));
          }
          onChangeMetaData = uploadFrontAddressProof === null || uploadFrontAddressProof === void 0 ? void 0 : uploadFrontAddressProof.onChangeMetaData;
          isValidObject(uploadFrontAddressProof === null || uploadFrontAddressProof === void 0 ? void 0 : uploadFrontAddressProof.onSelectValidFile) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, uploadFrontAddressProof === null || uploadFrontAddressProof === void 0 ? void 0 : uploadFrontAddressProof.onSelectValidFile), {
            type,
            action: 'upload',
            file
          }));
          break;
        case 'addressBack':
          updatedBackFileUpload = Object.assign({}, fileData);
          setBackfileUpload(prev => Object.assign(Object.assign({}, prev), updatedBackFileUpload));
          setShowBackUploadFiles(true);
          if (checked) {
            updatedBackIdentityUpload = Object.assign({}, fileData);
            setBackfileIdentityUpload(prev => Object.assign(Object.assign({}, prev), updatedBackIdentityUpload));
          }
          onChangeMetaData = uploadBackAddressProof === null || uploadBackAddressProof === void 0 ? void 0 : uploadBackAddressProof.onChangeMetaData;
          isValidObject(uploadBackAddressProof === null || uploadBackAddressProof === void 0 ? void 0 : uploadBackAddressProof.onSelectValidFile) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, uploadBackAddressProof === null || uploadBackAddressProof === void 0 ? void 0 : uploadBackAddressProof.onSelectValidFile), {
            type,
            action: 'upload',
            file
          }));
          break;
        case 'identityFront':
          updatedFrontIdentityUpload = Object.assign({}, fileData);
          setFrontfileIdenityUpload(prev => Object.assign(Object.assign({}, prev), updatedFrontIdentityUpload));
          setShowFrontIdentityUploadFiles(true);
          onChangeMetaData = uploadFrontIdProof === null || uploadFrontIdProof === void 0 ? void 0 : uploadFrontIdProof.onChangeMetaData;
          isValidObject(uploadFrontIdProof === null || uploadFrontIdProof === void 0 ? void 0 : uploadFrontIdProof.onSelectValidFile) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, uploadFrontIdProof === null || uploadFrontIdProof === void 0 ? void 0 : uploadFrontIdProof.onSelectValidFile), {
            type,
            action: 'upload',
            file
          }));
          break;
        case 'identityBack':
          updatedBackIdentityUpload = Object.assign({}, fileData);
          setBackfileIdentityUpload(prev => Object.assign(Object.assign({}, prev), updatedBackIdentityUpload));
          setShowBackIdentityUploadFiles(true);
          onChangeMetaData = uploadBackIdProof === null || uploadBackIdProof === void 0 ? void 0 : uploadBackIdProof.onChangeMetaData;
          isValidObject(uploadBackIdProof === null || uploadBackIdProof === void 0 ? void 0 : uploadBackIdProof.onSelectValidFile) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, uploadBackIdProof === null || uploadBackIdProof === void 0 ? void 0 : uploadBackIdProof.onSelectValidFile), {
            type,
            action: 'upload',
            file
          }));
          break;
        default:
          break;
      }
      isValidObject(onChangeMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onChangeMetaData), {
        type,
        action: 'upload',
        value: fileData === null || fileData === void 0 ? void 0 : fileData.subTitle
      }));
    } else {
      var errorFileState = Object.assign(Object.assign({}, fileData), {
        state: 'error',
        showDeleteIcon: false,
        hintText: getHintText(isSizeValid, isTypeValid)
      });
      switch (type) {
        case 'addressFront':
          setFrontfileUpload(Object.assign(Object.assign({}, errorFileState), {
            title: 'Front side'
          }));
          setShowFrontUploadFiles(true);
          break;
        case 'addressBack':
          setBackfileUpload(Object.assign(Object.assign({}, errorFileState), {
            title: 'Back side'
          }));
          setShowBackUploadFiles(true);
          break;
        case 'identityFront':
          setFrontfileIdenityUpload(Object.assign(Object.assign({}, errorFileState), {
            title: 'Front side'
          }));
          setShowFrontIdentityUploadFiles(true);
          break;
        case 'identityBack':
          setBackfileIdentityUpload(Object.assign(Object.assign({}, errorFileState), {
            title: 'Back side'
          }));
          setShowBackIdentityUploadFiles(true);
          break;
        default:
          break;
      }
    }
    handleValidation({
      addressProofValue,
      addressProofNumber,
      isChecked: checked,
      idProofValue,
      idProofNumber,
      frontfileUpload: updatedFrontFileUpload,
      backfileUpload: updatedBackFileUpload,
      frontfileIdentityUpload: updatedFrontIdentityUpload,
      backfileIdentityUpload: updatedBackIdentityUpload
    });
  };
  var handleDeleteIconPress = type => {
    var deleteFile = {
      state: 'none',
      showDeleteIcon: false
    };
    switch (type) {
      case 'addressFront':
        setFrontfileUpload(Object.assign({
          title: 'Front side'
        }, deleteFile));
        setShowFrontUploadFiles(false);
        return;
      case 'addressBack':
        setBackfileUpload(Object.assign({
          title: 'Back side'
        }, deleteFile));
        setShowBackUploadFiles(false);
        return;
      case 'identityFront':
        setFrontfileIdenityUpload(Object.assign({
          title: 'Front side'
        }, deleteFile));
        setShowFrontIdentityUploadFiles(false);
        return;
      case 'identityBack':
        setBackfileIdentityUpload(Object.assign({
          title: 'Back side'
        }, deleteFile));
        setShowBackIdentityUploadFiles(false);
        return;
      default:
        return;
    }
  };
  var handleChangeButtonPress = () => {
    setIsExpandedState(true);
  };
  var handleActionCtaPress = (type, proofType) => {
    var initialFileState = {
      title: type === 'front' ? 'Front side' : 'Back side',
      subTitle: '',
      state: 'none',
      showDeleteIcon: false
    };
    if (proofType === 'address') {
      if (type === 'front') {
        setShowFrontUploadFiles(false);
        setFrontfileUpload(initialFileState);
      } else {
        setShowBackUploadFiles(false);
        setBackfileUpload(initialFileState);
      }
    } else {
      if (type === 'front') {
        setShowFrontIdentityUploadFiles(false);
        setFrontfileIdenityUpload(initialFileState);
      } else {
        setBackfileIdentityUpload(initialFileState);
        setShowBackIdentityUploadFiles(false);
      }
    }
  };
  var renderProofSection = props => {
    return _jsx(ProofSection, Object.assign({}, props, {
      testID: testID,
      variant: variant,
      isDisabledState: isDisabledState,
      handleDropdownChange: handleDropdownChange,
      handleTextChange: handleTextChange,
      handleProofOnPressIn: handleProofOnPressIn,
      handleOnValidInputMetaData: handleOnValidInputMetaData,
      handleDeleteIconPress: handleDeleteIconPress,
      handleFileUpload: handleFileUpload,
      uploadDataText: uploadDataText,
      onUserAction: onUserAction,
      handleActionCtaPress: handleActionCtaPress
    }));
  };
  return isValidObject(_stepDetails) && _jsx(Collapsible, Object.assign({
    removeOverflow: true,
    titleNoVerticalPadding: true,
    titleNoHorizontalPadding: true,
    theme: theme,
    style: [skycFormWidgetStyle.heading, style],
    withCard: true,
    childPaddingToken: "SPACING_0",
    titlePaddingToken: "SPACING_0",
    showIcon: false,
    isExpanded: isExpandedState,
    disabled: getIsDisabledState(isDisabledState, disableToggle)
  }, getTestId(testID, variant + "_Collapsible"), {
    titleComponent: _jsx(IdentityTitleSection, {
      stepDetails: _stepDetails,
      successStateHeading: successStateHeading,
      onStepDetailsListItemPressMetaData: onStepDetailsListItemPressMetaData,
      onStepDetailsCtaPressMetaData: onStepDetailsCtaPressMetaData,
      handleChangeButtonPress: handleChangeButtonPress,
      onUserAction: onUserAction,
      variant: variant,
      testID: testID,
      subHeading: subHeading,
      isExpandedState: isExpandedState,
      isDisabledState: isDisabledState,
      isSuccessState: isSuccessState,
      successAvatarConfig: successAvatarConfig
    })
  }, {
    children: _jsxs(View, Object.assign({
      style: [skycFormWidgetStyle.content]
    }, {
      children: [_jsx(Callout, Object.assign({}, calloutProps, {
        theme: theme,
        style: identityProofWidgetStyle.calloutStyles
      }, getTestId(testID, variant + "_Callout"))), renderProofSection({
        proofType: 'address',
        uploadFrontFileProof: uploadFrontAddressProof,
        uploadBackFileProof: uploadBackAddressProof,
        dropdownProps: addressProofDropDown,
        inputProps: addressProofInputProps,
        showFrontUploadFiles: showFrontUploadFiles,
        showBackUploadFiles: showBackUploadFiles,
        frontFileUpload: frontfileUpload,
        backFileUpload: backfileUpload
      }), _jsx(Divider, Object.assign({
        height: 3,
        theme: theme,
        style: identityProofWidgetStyle.dividerStyles,
        color: BLACK_300
      }, getTestId(testID, variant + "_Divider"))), _jsx(Checkbox, Object.assign({}, checkboxProps, {
        theme: theme,
        checked: checked,
        onPress: onCheckboxPress,
        onActionCtaPress: () => {
          onCheckboxActionCtaPressMetaData && onUserAction(Object.assign({
            id
          }, onCheckboxActionCtaPressMetaData), checkboxProps);
        },
        disabled: getIsDisabledState(isDisabledState, checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.disabled),
        style: [identityProofWidgetStyle.checkboxStyles]
      }, getTestId(testID, variant + "_Checkbox"))), !checked && renderProofSection({
        proofType: 'identity',
        uploadFrontFileProof: uploadFrontIdProof,
        uploadBackFileProof: uploadBackIdProof,
        dropdownProps: idProofDropDown,
        inputProps: idProofInputProps,
        showFrontUploadFiles: showFrontIdenityUploadFiles,
        showBackUploadFiles: showBackIdentityUploadFiles,
        frontFileUpload: frontfileIdentityUpload,
        backFileUpload: backfileIdentityUpload,
        idProofNumber: idProofNumber
      })]
    }))
  }));
};